const IMAGE_TIMEOUT_MS = 8000

const readAsDataUri = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(blob)
  })

const request = async (url: string): Promise<string> => {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  const type = res.headers.get('content-type') ?? ''
  if (!type.startsWith('image/')) throw new Error(`Not an image: ${type}`)
  return readAsDataUri(await res.blob())
}

export const fetchImageDataUri = (
  url: string,
  timeoutMs = IMAGE_TIMEOUT_MS
): Promise<string | undefined> =>
  new Promise((resolve) => {
    const timer = setTimeout(() => {
      console.warn(`Image ${url} timed out`)
      resolve(undefined)
    }, timeoutMs)
    request(url).then(
      (uri) => {
        clearTimeout(timer)
        resolve(uri)
      },
      (error) => {
        clearTimeout(timer)
        console.warn(`Image ${url} could not be loaded:`, error)
        resolve(undefined)
      }
    )
  })
